import { createRoot } from "react-dom/client";
import "@repo/core/theme/global.css";
import { AppRoutes } from "./routes";
import { AppProviders } from "./providers";

import { bootstrapReactNativeVectorIcons } from "../config/react-native-vector-icons";

bootstrapReactNativeVectorIcons();

const root = createRoot(document.getElementById("root")!);

root.render(
  <AppProviders>
    <AppRoutes />
  </AppProviders>
);
